// extracted by mini-css-extract-plugin
module.exports = {"header-image":"_Layout_header-image_10TZB","layout-size":"_Layout_layout-size_2OYDG","layout-color":"_Layout_layout-color_3aJcI","terms":"_Layout_terms_2HN5_"};